import { Entry } from './entry';

Entry.displayName = 'AvatarStackMack';

export { Entry as Mask };
